var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.cssClass())},[_c('page-controller')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }